/**
 * Snapshot the files selected in a file <input> and reset the control.
 *
 * `input.files` is a *live* FileList bound to the element, so it must be copied
 * with Array.from *before* the value is cleared. Deferring the copy (e.g. inside
 * a React state updater) or clearing the input first empties the list and drops
 * the selection — this is the bug where a second "attach" silently added nothing.
 *
 * The input is reset so selecting the same file again still fires `change`.
 */
export function takeSelectedFiles(input: HTMLInputElement): File[] {
  const files = input.files ? Array.from(input.files) : [];
  input.value = '';
  return files;
}
